import { render, staticRenderFns } from "./SysCheckRuleList.vue?vue&type=template&id=bc4883c4&scoped=true&"
import script from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
import style0 from "./SysCheckRuleList.vue?vue&type=style&index=0&id=bc4883c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4883c4",
  null
  
)

export default component.exports